import { useTranslation } from "react-i18next";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import type React from "react";

export default function CtaBanner() {
  const { t } = useTranslation();
  const { ref: contentRef, isVisible: contentVisible } = useScrollAnimation();

  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Okinawa%20sunset%20panoramic%20ocean%20view%20dramatic%20golden%20orange%20sky%20reflecting%20on%20calm%20turquoise%20sea%20water%20silhouette%20of%20tropical%20trees%20peaceful%20serene%20atmosphere%20wide%20angle%20landscape%20photography%20warm%20golden%20hour%20light&width=1440&height=600&seq=cta001&orientation=landscape"
          alt="沖縄の夕暮れ"
          className="w-full h-full object-cover object-top"
          loading="lazy"
          decoding="async"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6">
        <div
          ref={contentRef as React.RefObject<HTMLDivElement>}
          className={`max-w-2xl transition-all ease-out ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}
          style={{ transitionDuration: "800ms" }}
        >
          <h2
            className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6"
            style={{ fontFamily: "'Noto Serif JP', serif" }}
          >
            {t("cta_heading1")}<br />
            {t("cta_heading2")}
          </h2>
          <button
            onClick={() => handleNav("#contact")}
            className="group inline-flex items-center gap-3 bg-white text-gray-800 font-bold px-6 sm:px-8 py-3.5 sm:py-4 rounded-full hover:bg-[#0ABAB5] hover:text-white transition-all duration-300 text-sm sm:text-base whitespace-nowrap cursor-pointer"
          >
            {t("cta_btn")}
            <span className="w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center rounded-full bg-gray-800 group-hover:bg-white transition-colors duration-300">
              <i className="ri-arrow-right-line text-white group-hover:text-[#0ABAB5] text-sm transition-colors duration-300" />
            </span>
          </button>
        </div>
      </div>
    </section>
  );
}
